// Initializes PostHog on the client for analytics and error tracking.
// https://posthog.com/docs/libraries/next-js

import {
  initClientAnalytics,
  onRouterTransitionStart,
} from "@traqly/analytics/instrumentation-client";

initClientAnalytics({
  posthog: {
    apiKey: process.env.NEXT_PUBLIC_POSTHOG_KEY!,
    apiHost:
      process.env.NODE_ENV === "development"
        ? "https://us.i.posthog.com"
        : "/ingest",
    uiHost: "https://us.posthog.com",
    debug: process.env.NODE_ENV === "development",
  },
});

export { onRouterTransitionStart };
